<template>
  <div>
    <b-modal
      v-model="modalShow"
      ref="modalGroupEdit"
      size="xl"
      :title="modalTitle"
      hideFooter
    >
      <group-edit-form
        ref="groupForm"
        @onClickSave="processGroupSaved()"
        @onClickExit="hideModal"
      />
    </b-modal>
  </div>
</template>

<script>
import GroupEditForm from "@/components/groups/GroupsEditForm";

export default {
  name: "edit-group-modal",
  components: {
    "group-edit-form": GroupEditForm,
  },
  data() {
    return {
      modalShow: false,
      modalTitle: "Grupo",
    };
  },
  methods: {
    processGroupSaved() {
      // Hide modal
      this.modalShow = false;

      this.$emit("onClickSave");
    },

    showModal(id, location) {
      if (id) {
        this.modalTitle = "Grupo - Modificar";
      } else {
        this.modalTitle = "Grupo - Crear nueva agrupación de sensores";
      }

      this.modalShow = true;
      this.$refs.modalGroupEdit.show();

      if (id) {
        this.$nextTick(() => {
          // DOM updated
          this.$refs.groupForm.retrieveGroupDetails(id, location);
        });
      } else {
        this.$nextTick(() => {
          this.$refs.groupForm.retrieveLocations(location);
        });
      }
    },

    hideModal() {
      this.modalShow = false;
    },
  },
};
</script>